<template>
  <ContentWrap>
    <el-form ref="queryFormRef" :inline="true" :model="queryParams" class="-mb-15px" label-width="80px">
      <el-form-item label="昵称" prop="nickname">
        <el-input
          v-model="queryParams.nickname"
          class="!w-180px"
          clearable
          placeholder="会员昵称"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="queryParams.status" class="!w-140px" clearable placeholder="全部">
          <el-option
            v-for="o in AREA_AGENT_USER_STATUS"
            :key="o.value"
            :label="o.label"
            :value="o.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="类型" prop="agentType">
        <el-select v-model="queryParams.agentType" class="!w-130px" clearable placeholder="全部">
          <el-option
            v-for="o in AREA_AGENT_TYPE"
            :key="o.value"
            :label="o.label"
            :value="o.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="等级" prop="levelId">
        <el-select v-model="queryParams.levelId" class="!w-140px" clearable placeholder="全部">
          <el-option v-for="l in levelOptions" :key="l.id" :label="l.name" :value="l.id" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="warning" @click="filterPending">待审核</el-button>
        <el-button type="warning" plain @click="filterNeedArea">待完善辖区</el-button>
        <el-button @click="handleQuery"><Icon class="mr-5px" icon="ep:search" />搜索</el-button>
        <el-button @click="resetQuery"><Icon class="mr-5px" icon="ep:refresh" />重置</el-button>
        <el-button
          v-hasPermi="['distribution:area-agent:user:update']"
          plain
          type="primary"
          @click="openCreate"
        >
          <Icon class="mr-5px" icon="ep:plus" />指定代理
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list" :stripe="true" :show-overflow-tooltip="true">
      <el-table-column align="center" label="编号" prop="id" width="70" />
      <el-table-column align="center" label="头像" width="70">
        <template #default="{ row }">
          <el-avatar :src="row.avatar" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="会员" min-width="140">
        <template #default="{ row }">
          <div>{{ row.nickname || '-' }}</div>
          <div class="text-xs text-gray-400">ID:{{ row.userId }} {{ row.mobile || '' }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="类型" width="100">
        <template #default="{ row }">
          {{ row.agentTypeName || labelOf(AREA_AGENT_TYPE, row.agentType) || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="辖区" prop="areaNames" min-width="120" />
      <el-table-column align="center" label="等级" prop="levelName" min-width="90" />
      <el-table-column align="center" label="状态" width="110">
        <template #default="{ row }">
          <el-tag :type="tagTypeOf(AREA_AGENT_USER_STATUS, row.status)" size="small">
            {{ labelOf(AREA_AGENT_USER_STATUS, row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="累计分红" min-width="90">
        <template #default="{ row }">￥{{ fenToYuan(row.totalBonus || 0) }}</template>
      </el-table-column>
      <el-table-column align="center" label="已提现" min-width="90">
        <template #default="{ row }">￥{{ fenToYuan(row.withdrawBonus || 0) }}</template>
      </el-table-column>
      <el-table-column align="center" label="冻结" min-width="90">
        <template #default="{ row }">￥{{ fenToYuan(row.freezeBonus || 0) }}</template>
      </el-table-column>
      <el-table-column
        align="center"
        label="成为时间"
        prop="becomeTime"
        :formatter="dateFormatter"
        width="170"
      />
      <el-table-column align="center" label="操作" fixed="right" width="260">
        <template #default="{ row }">
          <template v-if="row.status === 0">
            <el-button
              v-hasPermi="['distribution:area-agent:user:audit']"
              link
              type="primary"
              @click="openAudit(row, true)"
            >
              通过
            </el-button>
            <el-button
              v-hasPermi="['distribution:area-agent:user:audit']"
              link
              type="danger"
              @click="openAudit(row, false)"
            >
              拒绝
            </el-button>
          </template>
          <template v-if="row.status === 5">
            <el-button
              v-hasPermi="['distribution:area-agent:user:update']"
              link
              type="primary"
              @click="openArea(row)"
            >
              补全辖区
            </el-button>
          </template>
          <template v-if="row.status === 1">
            <el-button
              v-hasPermi="['distribution:area-agent:user:update']"
              link
              type="primary"
              @click="openLevel(row)"
            >
              改等级
            </el-button>
            <el-button
              v-hasPermi="['distribution:area-agent:user:update']"
              link
              type="primary"
              @click="openArea(row)"
            >
              改辖区
            </el-button>
            <el-button
              v-hasPermi="['distribution:area-agent:user:update']"
              link
              type="warning"
              @click="changeStatus(row, 3)"
            >
              禁用
            </el-button>
            <el-button
              v-hasPermi="['distribution:area-agent:user:update']"
              link
              type="danger"
              @click="changeStatus(row, 4)"
            >
              黑名单
            </el-button>
          </template>
          <template v-if="row.status === 3 || row.status === 4">
            <el-button
              v-hasPermi="['distribution:area-agent:user:update']"
              link
              type="primary"
              @click="changeStatus(row, 1)"
            >
              恢复正常
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <AreaAgentUserCreateForm ref="createRef" @success="getList" />
  <AreaAgentUserAuditForm ref="auditRef" @success="getList" />
  <AreaAgentUserLevelForm ref="levelRef" @success="getList" />
  <AreaAgentUserAreaForm ref="areaRef" @success="getList" />
</template>

<script lang="ts" setup>
import { dateFormatter } from '@/utils/formatTime'
import { fenToYuan } from '@/utils'
import * as UserApi from '@/api/mall/trade/areaAgent/user'
import * as LevelApi from '@/api/mall/trade/areaAgent/level'
import {
  AREA_AGENT_TYPE,
  AREA_AGENT_USER_STATUS,
  labelOf,
  tagTypeOf
} from '../constants'
import AreaAgentUserCreateForm from './AreaAgentUserCreateForm.vue'
import AreaAgentUserAuditForm from './AreaAgentUserAuditForm.vue'
import AreaAgentUserLevelForm from './AreaAgentUserLevelForm.vue'
import AreaAgentUserAreaForm from './AreaAgentUserAreaForm.vue'

defineOptions({ name: 'TradeAreaAgentUser' })

const message = useMessage()
const loading = ref(false)
const list = ref<UserApi.AreaAgentUserVO[]>([])
const total = ref(0)
const levelOptions = ref<LevelApi.AreaAgentLevelSimpleVO[]>([])
const queryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  nickname: undefined as string | undefined,
  status: undefined as number | undefined,
  agentType: undefined as number | undefined,
  levelId: undefined as number | undefined
})
const queryFormRef = ref()
const createRef = ref()
const auditRef = ref()
const levelRef = ref()
const areaRef = ref()

const getList = async () => {
  loading.value = true
  try {
    const data = await UserApi.getAreaAgentUserPage(queryParams)
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryFormRef.value?.resetFields()
  handleQuery()
}

const filterPending = () => {
  queryParams.status = 0
  handleQuery()
}

const filterNeedArea = () => {
  queryParams.status = 5
  handleQuery()
}

const openCreate = () => createRef.value?.open()
const openAudit = (row: UserApi.AreaAgentUserVO, approved: boolean) =>
  auditRef.value?.open(row, approved)
const openLevel = (row: UserApi.AreaAgentUserVO) => levelRef.value?.open(row)
const openArea = (row: UserApi.AreaAgentUserVO) => areaRef.value?.open(row)

const changeStatus = async (row: UserApi.AreaAgentUserVO, status: number) => {
  const tip =
    status === 1 ? '确认恢复为正常代理？' : status === 3 ? '确认禁用该代理？' : '确认加入黑名单？'
  try {
    await message.confirm(tip)
    await UserApi.updateAreaAgentUserStatus({ id: row.id!, status })
    message.success('操作成功')
    await getList()
  } catch {}
}

onMounted(async () => {
  levelOptions.value = (await LevelApi.getAreaAgentLevelSimpleList()) || []
  await getList()
})
</script>
